import script from "./dropdown.vue?vue&type=script&setup=true&lang=ts"
export * from "./dropdown.vue?vue&type=script&setup=true&lang=ts"

import "./dropdown.vue?vue&type=style&index=0&id=f12621dc&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f12621dc"]])

export default __exports__